import styled from '@emotion/styled';

export const Container = styled.div`
  background-color: ${({ theme }): string => theme.SECONDARY};
  width: 100%;
  height: 70px;

  display: flex;
  align-items: center;
  padding: 0px 10px 0px 18px;
`;

export const SideBarButton = styled.button<{ isOpen: boolean }>`
  width: 28px;
  height: 28px;
  border-radius: 4px;

  display: flex;
  align-items: center;
  justify-content: center;

  -webkit-transition: 0.25s ease-in-out;
  -moz-transition: 0.25s ease-in-out;
  -o-transition: 0.25s ease-in-out;
  transition: 0.25s ease-in-out;

  ${({ isOpen }): string => (isOpen ? '' : 'transform: rotate(180deg)')};

  cursor: pointer;
`;

export const Menu = styled.ul`
  margin-left: 40px;
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const MenuItem = styled.li<{ selected: boolean }>`
  cursor: pointer;

  font-weight: 400;
  font-size: 18px;
  color: ${({ theme, selected }): string => (selected ? theme.PRIMARY : theme.WHITE)};
`;

export const Logo = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 0 10px;
  margin-left: 18px;
`;

export const User = styled.div`
  margin-left: auto;
`;
